import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { useAcademicYear } from '../contexts/AcademicYearContext';

export const useAcademicYearQuery = (queryKey) => {
  const queryClient = useQueryClient();
  const { selectedYear } = useAcademicYear();

  useEffect(() => {
    // Listen for academic year changes
    const handleYearChange = () => {
      // Invalidate queries when year changes
      if (Array.isArray(queryKey)) {
        queryClient.invalidateQueries(queryKey);
      } else {
        queryClient.invalidateQueries([queryKey]);
      }
    };

    window.addEventListener('academicYearChanged', handleYearChange);
    
    return () => {
      window.removeEventListener('academicYearChanged', handleYearChange);
    };
  }, [queryClient, queryKey]);

  // Return params with academic year
  return {
    yearParams: selectedYear ? { annee_scolaire_id: selectedYear.id } : {}
  };
};